import type { BlockImage } from 'shared-types';

type LocaleData = BlockImage['locales'][string];

const defaultBlockData = {};

const translatable: LocaleData['translatable'] = {
  altText: '',
  caption: ''
};
const defaultLocaleData: LocaleData = {
  file: null,
  maxWidth: null,
  translatable
};

const localePlaceholders = {
  altText: '{{ locales.translatable.altText }}' as const,
  caption: '{{ locales.translatable.caption }}' as const,
  file: '{{ locales.file }}' as const,
  maxWidth: '{{ locales.maxWidth }}' as const
};

export const defaults = {
  defaultBlockData,
  defaultLocaleData,
  localePlaceholders
};

export const blockImageData: BlockImage = {
  ...defaultBlockData,
  ...localePlaceholders,
  locales: new Proxy({} as BlockImage['locales'], {
    get: (locales, languageVersion: string) => {
      return (locales[languageVersion] = defaultLocaleData);
    }
  })
};
